import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { DashboardHome, MyArticles } from './ReporterDashboard';
import Article from './Article';
import EditArticle from './EditArticle';

function ReporterRoutes({ 
  onViewArticle,
  editingArticleId, 
  setEditingArticleId, 
  editingArticleData, 
  setEditingArticleData
}) {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/reporter/dashboard" />} />
      <Route path="/dashboard" element={<DashboardHome />} />
      <Route path="/myarticles" element={<MyArticles onViewArticle={onViewArticle} />} />
      <Route path="/addnewsarticle" element={<Article />} />
      <Route path="/editarticle/:id" element={
        editingArticleId ? (
          <EditArticle 
            articleId={editingArticleId} 
            articleData={editingArticleData}
            onBack={() => {
              console.log('🔙 Going back to my articles list');
              setEditingArticleId(null);
              setEditingArticleData(null);
            }} 
          />
        ) : (
          <Navigate to="/reporter/myarticles" />
        )
      } />
      <Route path="*" element={<Navigate to="/reporter/dashboard" />} />
    </Routes>
  );
}

export default ReporterRoutes;
